import { Variants } from 'framer-motion';

// === DURATION CONSTANTS ===
const DURATIONS = {
    FAST: 0.15,
    STORY_TRANSITION: 0.18,
    PANEL_SLIDE: 0.22,
    HOVER: 0.2
} as const;

// === EASING CONFIGURATIONS ===
const EASINGS = {
    EASE_OUT: [0.4, 0, 0.2, 1],
    EASE_IN_OUT: [0.4, 0, 0.2, 1]
} as const;

// === SPRING CONFIGURATIONS ===
export const SPRING_CONFIGS = {
    // Smooth and responsive - good for carousels and main interactions
    SMOOTH: {
        type: 'spring' as const,
        stiffness: 300,
        damping: 30,
        mass: 1
    },
    
    // Bouncy and playful - good for hover effects and buttons
    BOUNCY: {
        type: 'spring' as const,
        stiffness: 400,
        damping: 25,
        mass: 0.8
    },
    
    // Quick and snappy - good for small interactions
    SNAPPY: {
        type: 'spring' as const,
        stiffness: 800,
        damping: 35,
        bounce: 0.1
    }
} as const;

// === TRANSITION CONFIGURATIONS ===
export const TRANSITIONS = {
    FAST_EASE_OUT: {
        duration: DURATIONS.FAST,
        ease: EASINGS.EASE_OUT
    },
    
    HOVER: {
        duration: DURATIONS.HOVER,
        ease: EASINGS.EASE_OUT
    }
} as const;

// === COMMON ANIMATION VARIANTS ===

export const HOVER_VARIANTS: Variants = {
    initial: {
        scale: 1,
        transition: TRANSITIONS.HOVER
    },
    hover: {
        scale: 1.05,
        transition: SPRING_CONFIGS.BOUNCY
    },
    tap: {
        scale: 0.95,
        transition: TRANSITIONS.FAST_EASE_OUT
    }
};

export const BUTTON_VARIANTS: Variants = {
    initial: {
        scale: 1
    },
    hover: {
        scale: 1.02,
        transition: TRANSITIONS.HOVER
    },
    tap: {
        scale: 0.95,
        transition: {
            duration: 0.1,
            ease: EASINGS.EASE_OUT
        }
    }
};

// === SPECIALIZED ANIMATION PRESETS ===

// Panel slide down animations (for avatar carousel panels)
export const PANEL_SLIDE_VARIANTS: Variants = {
    hidden: {
        y: -32,
        opacity: 0,
        height: 0,
        transition: {
            duration: DURATIONS.PANEL_SLIDE,
            ease: EASINGS.EASE_IN_OUT
        }
    },
    visible: {
        y: 0,
        opacity: 1,
        height: 'auto',
        transition: SPRING_CONFIGS.SNAPPY
    },
    exit: {
        y: -32,
        opacity: 0,
        height: 0,
        transition: {
            duration: DURATIONS.STORY_TRANSITION,
            ease: EASINGS.EASE_IN_OUT
        }
    }
};

export const BUBBLE_VARIANTS: Variants = {
    initial: {
        scale: 1,
        transition: TRANSITIONS.HOVER
    },
    hover: {
        scale: 1.05,
        transition: SPRING_CONFIGS.BOUNCY
    },
    open: {
        scale: 1.1,
        transition: SPRING_CONFIGS.SMOOTH
    }
};

// === ANIMATION UTILITIES ===

export const PERFORMANCE_PROPS = {
    style: { willChange: 'transform' },
    
    // Reduce layout thrashing
    layoutId: undefined,
    
    // Use GPU acceleration
    transformTemplate: ({ x, y, scale }: any) => 
        `translate3d(${x}, ${y}, 0) scale(${scale})`
};

